<template>
  <div class="pages">
    <el-button
      size="small"
      style=" margin-bottom: .16rem;"
      icon="el-icon-arrow-left"
      @click="backHandler"
      >返回</el-button
    >
    <el-row :gutter="25" type="flex">
      <el-col :span="15">
        <el-card class="box-card detail">
          <div class="flex-row section_3 items-start">
            <div class="flex-col group_6">
              <el-image
                class="image_5"
                :src="apiUrl + userInfo.head"
                :preview-src-list="[apiUrl + userInfo.head]"
              >
                <div slot="error" class="el-image__error">
                  {{ !userInfo.head ? "暂无图片" : "加载失败" }}
                </div>
              </el-image>
            </div>
            <div class="flex-col" style="width: 5.4rem">
              <div class="flex-row justify-between">
                <div class="flex-col group_7">
                  <div class="flex-row group_8">
                    <span
                      class="text_11"
                      style="font-size: 0.2rem; font-weight: 700"
                      >{{ userInfo.name || "-" }}</span
                    >
                    <i
                      v-if="userInfo.sex == '女'"
                      style="color: #f4786f; font-size: 28px"
                      class="el-icon-female image_6"
                    ></i>
                    <i
                      v-if="userInfo.sex == '男'"
                      style="color: #2e9bff; font-size: 28px"
                      class="el-icon-male image_6"
                    ></i>
                  </div>
                  <div v-if="userInfo.role == '企业'" class="text_12">
                    <div
                      v-for="(v2, i2) in allowCompanyList"
                      :key="i2"
                      class="text_12"
                    >
                      {{ v2.businessName || "-" }}{{ userInfo.role || "-" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-row group_9">
                <span
                  ><i class="el-icon-user" style="margin-right: 0.1rem"></i
                  >{{ userInfo.role || "-" }}</span
                >
                <span
                  ><i
                    class="el-icon-mobile-phone"
                    style="margin-right: 0.1rem"
                  ></i
                  >电话：{{ userInfo.phone || "-" }}</span
                >
                <span
                  ><i class="el-icon-location" style="margin-right: 0.1rem"></i
                  >{{ userInfo.address || "-" }}</span
                >
              </div>
              <!-- <div class="flex-row group_9">
                <span
                  ><i
                    class="el-icon-postcard"
                    style="margin-right: 0.1rem"
                  ></i
                  >身份证号：{{ userInfo.idCard || '-' }}</span
                >
              </div> -->
              <div
                style="display: flex; width: 85%; flex-wrap: wrap; margin-top:20px"
                v-if="userInfo.role == '管理员'"
                class="text_12"
              >
                <span
                  v-for="(v, i) in allowAdminList"
                  :key="i"
                  class="adminInfo"
                >
                  {{ v.schoolName || "-" }}{{ userInfo.role || "-" }}
                </span>
              </div>
            </div>
            <div class="flex-row">
              <div class="resume" @click="dialogVisible = true">
                <img src="../../assets/images/jianli.png" alt="" />
                <span>{{ "个人简历 >" }}</span>
              </div>
            </div>
            <template v-for="(v, idx) in educationsList" v-if="false">
              <div :key="idx">
                <div class="group_10 flex-col items-start view">
                  <span class="text_16">教育信息{{ idx + 1 }}</span>
                  <span class="text_18"
                    >学校名称：{{ v.schoolName || "-" }}</span
                  >
                  <span class="text_18">学历：{{ v.educationStr || "-" }}</span>
                  <span class="text_18">学院：{{ v.college || "-" }}</span>
                  <span class="text_18">专业：{{ v.major || "-" }}</span>
                  <span class="text_18"
                    >在校时间：{{ v.startYear }}-{{ v.endYear }}</span
                  >
                </div>
                <div class="divider"></div>
              </div>
            </template>
          </div>
        </el-card>
      </el-col>
      <el-col :span="9">
        <el-card class="box-card detail">
          <div class="block">
            <el-carousel
              v-if="educationsList.length"
              :autoplay="false"
              trigger="click"
              height="150px"
              arrow="always"
            >
              <el-carousel-item v-for="(v, idx) in educationsList" :key="idx">
                <h2 class="eduSchool">{{ v.schoolName || "-" }}</h2>
                <div class="boxInfo">
                  <div style="margin-top: 20px">
                    <img
                      style="vertical-align: middle"
                      src="../../assets/images/education.png"
                      alt=""
                    />
                    学历：{{ v.educationStr || "-" }}
                  </div>
                  <div style="display: flex; margin: 15px 0">
                    <span style="width: 60%">
                      <img
                        class="iconImg"
                        src="../../assets/images/schoolName.png"
                        alt=""
                      />学校名称：{{ v.schoolName || "-" }}</span
                    >
                    <span>
                      <img
                        class="iconImg"
                        src="../../assets/images/majorName.png"
                        alt=""
                      />专业：{{ v.major || "-" }}</span
                    >
                  </div>
                  <div style="display: flex">
                    <span style="width: 60%">
                      <img
                        class="iconImg"
                        src="../../assets/images/collegeName.png"
                        alt=""
                      />学院：{{ v.college || "-" }}</span
                    >
                    <span>
                      <img
                        class="iconImg"
                        src="../../assets/images/duringTime.png"
                        alt=""
                      />在校时间：{{ v.startYear }}-{{ v.endYear }}</span
                    >
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <el-empty
              class="carousel_empty"
              :image="emptyImg"
              v-if="educationsList.length <= 0"
            ></el-empty>
          </div>
          <template v-for="(v, idx) in educationsList" v-if="false">
            <div :key="idx">
              <div class="group_10 flex-col items-start view">
                <span class="text_16">教育信息{{ idx + 1 }}</span>
                <span class="text_18">学校名称：{{ v.schoolName || "-" }}</span>
                <span class="text_18">学历：{{ v.educationStr || "-" }}</span>
                <span class="text_18">学院：{{ v.college || "-" }}</span>
                <span class="text_18">专业：{{ v.major || "-" }}</span>
                <span class="text_18"
                  >在校时间：{{ v.startYear }}-{{ v.endYear }}</span
                >
              </div>
              <div class="divider"></div>
            </div>
          </template>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 30px">
      <el-col :span="24">
        <el-card class="box-card">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-if="userInfo.article_Infos != null"
              :label="`发布内容（${userInfo.article_Infos.length || 0}）`"
              name="0"
            >
              <release :publishContent="userInfo.article_Infos"></release>
            </el-tab-pane>
            <el-tab-pane
              v-if="userInfo.educations != null"
              :label="`教育经历认证（${userInfo.educations.length || 0}）`"
              name="1"
            >
              <education :currStudentInfo="userInfo.educations"></education>
            </el-tab-pane>
            <el-tab-pane
              v-if="userInfo.attestation_JZG != null"
              :label="`教职工认证（${userInfo.attestation_JZG.length || 0}）`"
              name="2"
            >
              <Faculty :currTeacherInfo="userInfo.attestation_JZG"></Faculty>
            </el-tab-pane>
            <el-tab-pane
              v-if="userInfo.attestation_GLY != null"
              :label="`管理员认证（${userInfo.attestation_GLY.length || 0}）`"
              name="3"
            >
              <admin :currAdminInfo="userInfo.attestation_GLY"></admin>
            </el-tab-pane>
            <el-tab-pane
              v-if="userInfo.attestation_QY != null"
              :label="`企业认证（${userInfo.attestation_QY.length || 0}）`"
              name="4"
            >
              <enterprise
                :currEnterpriseInfo="userInfo.attestation_QY"
              ></enterprise>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      title="个人简历"
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
    >
      <div class="dialog-body">
        <div class="user-top" style="padding:0 .4rem">
          <div class="user-name">
            <div class="name">{{ resumeData.user.name || "-" }}</div>
            <div class="tag">
              {{ resumeData.user.workField.workFieldName || "-" }}
            </div>
          </div>
          <div
            class="file"
            @click="downloadFile(userFile.length ? userFile[0].url : null)"
          >
            <img src="../../assets/images/link.png" alt="" />
            简历附件
          </div>
        </div>
        <div class="user-info" style="padding:0 .4rem">
          <div class="title">个人信息</div>
          <div class="edu-list">
            <div class="edu-item">
              <div class="name">学历</div>
              <div class="value">
                {{
                  resumeData.educationList
                    .filter(item => item.isSelected)
                    .map(item => item.educationStr || "-")
                    .join(", ")
                }}
              </div>
            </div>
            <div class="edu-item">
              <div class="name">学院</div>
              <div class="value">
                {{
                  resumeData.educationList
                    .filter(item => item.isSelected)
                    .map(item => item.college || "-")
                    .join(", ")
                }}
              </div>
            </div>
            <div class="edu-item">
              <div class="name">专业</div>
              <div class="value">
                {{
                  resumeData.educationList
                    .filter(item => item.isSelected)
                    .map(item => item.major || "-")
                    .join(", ")
                }}
              </div>
            </div>
            <div class="edu-item">
              <div class="name">手机号</div>
              <div class="value">{{ resumeData.user.phone || "-" }}</div>
            </div>
          </div>
        </div>
        <el-tabs
          class="user-tabs"
          v-model="activeName2"
          @tab-click="handleClick2"
        >
          <el-tab-pane label="教育经历" name="first">
            <div class="tab-main">
              <div class="through-list">
                <div
                  class="through-item"
                  v-for="(v, i) in resumeData.educationList"
                  :key="i"
                >
                  <div class="time-line">
                    <div class="time">
                      {{ formatDate(v.startYear) || "-" }}—{{
                        formatDate(v.endYear) || "-"
                      }}
                    </div>
                    <div class="position">{{ v.school.name || "-" }}</div>
                  </div>
                  <div class="company-name" style="margin-bottom:0">
                    {{ v.educationStr || "-" }}·{{ v.college || "-" }}
                  </div>
                </div>
              </div>
            </div></el-tab-pane
          >
          <el-tab-pane label="工作经历" name="second">
            <div class="tab-main">
              <div class="through-list">
                <div
                  class="through-item"
                  v-for="(v, i) in resumeData.workInfoList"
                  :key="i"
                >
                  <div class="time-line">
                    <div class="time">
                      {{ formatDate(v.startTime) || "-" }}—{{
                        formatDate(v.endTime) || "-"
                      }}
                    </div>
                    <div class="position">{{ v.corporatePosition || "-" }}</div>
                  </div>
                  <div class="company-name">{{ v.corporateName || "-" }}</div>
                  <div class="work-description">
                    <div class="title">工作描述：</div>
                    <div class="work-inner">
                      {{ v.wordDesc || "-" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="项目经历" name="third">
            <div class="tab-main">
              <div class="through-list">
                <div
                  class="through-item"
                  v-for="(v, i) in resumeData.projectInfoList"
                  :key="i"
                >
                  <div class="time-line">
                    <div class="time">
                      {{ formatDate(v.startTime) || "-" }}—{{
                        formatDate(v.endTime) || "-"
                      }}
                    </div>
                    <div class="position">{{ v.projectPosition || "-" }}</div>
                  </div>
                  <div class="company-name">{{ v.projectName || "-" }}</div>
                  <div class="work-description">
                    <div class="title">项目描述：</div>
                    <div class="work-inner">
                      {{ v.projectDesc || "-" }}
                    </div>
                  </div>
                </div>
              </div>
            </div></el-tab-pane
          >
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import enterprise from "../../components/userDetail/enterprise.vue"; //企业认证
import admin from "../../components/userDetail/admin.vue"; //管理员认证
import Faculty from "../../components/userDetail/Faculty.vue"; //教职工认证
import education from "../../components/userDetail/education.vue"; //教育经历认证
import release from "../../components/userDetail/release.vue"; //发布内容
import dayjs from "dayjs";
import { ResumeUserApi, GetUserFileApi } from "@/request/requestApi.js";

export default {
  data() {
    return {
      emptyImg: require("../../assets/images/emptyImg.png"),
      activeName2: "first",
      dialogVisible: false,
      apiUrl: "",
      activeName: "0",
      //用户信息
      userInfo: { name: "", educations: [] },
      resumeData: { user: { workField: {} }, educationList: [] },
      userFile: []
    };
  },
  computed: {
    //左侧展示已通过的教育信息
    educationsList() {
      console.log(this.userInfo.educations);
      return this.userInfo.educations.filter(item => {
        return item.state == 1;
      });
    },
    //已通过的企业信息
    allowCompanyList() {
      return this.userInfo.attestation_QY.filter(item => {
        return item.state == 1;
      });
    },
    //已通过的学校管理员信息展示
    allowAdminList() {
      console.log(this.userInfo.attestation_GLY);
      return this.userInfo.attestation_GLY.filter(item => {
        console.log(item.state);
        console.log(item.schoolName);
        return item.state == 1;
      });
    }
  },
  created() {
    if (this.$route.query.role == "user" || this.$route.query.role == "admin") {
      this.getUserInfo();
      this.getResumeUser();
      this.getUserFileApi();
    } else if (this.$route.query.role == "company") {
      this.getCompanyInfo();
    }
    this.apiUrl = window.api.apiurl;
  },
  methods: {
    backHandler() {
      if (this.$route.query.role == "admin") {
        this.$router.push({
          name: "admin",
          params: {
            pageIdx: this.$route.query.pageIdx,
            pageSize: this.$route.query.pageSize
          }
        });
      } else if (this.$route.query.role == "company") {
        this.$router.push({
          name: "enterprise",
          params: {
            pageIdx: this.$route.query.pageIdx,
            pageSize: this.$route.query.pageSize
          }
        });
      } else if (this.$route.query.role == "user") {
        this.$router.push({
          name: "user",
          params: {
            pageIdx: this.$route.query.pageIdx,
            pageSize: this.$route.query.pageSize
          }
        });
      }
    },
    downloadFile(fileUrl) {
      console.log(fileUrl);
      if (!fileUrl) {
        return this.$message.error("该用户暂未上传简历附件");
      }
      // 设置要下载的文件的 URL
      const url = window.api.apiurl + fileUrl; // 替换为实际的文件 URL
      // 在新窗口中打开文件
      window.open(url, "_blank");
    },
    formatDate(date) {
      // 检查 date 是否为有效日期
      const parsedDate = dayjs(date);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "-";
    },
    handleClose() {
      this.dialogVisible = false;
      this.activeName2 = "first";
    },
    handleClick() {},
    handleClick2() {},
    getUserInfo() {
      this.$api
        .get("/admin/User/GetUserInfo?id=" + this.$route.query.id)
        .then(res => {
          if (res.succeed) {
            this.userInfo = res.data;
            this.userInfo.roleText =
              this.userInfo.role == 1
                ? "校友"
                : this.userInfo.role == 2
                ? "企业"
                : this.userInfo.role == 3
                ? "教职工"
                : this.userInfo.role == 4
                ? "管理员"
                : this.userInfo.role == 5
                ? "在校生"
                : "";

            console.log(this.userInfo);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    getCompanyInfo() {
      this.$api
        .get("/admin/QY/GetQYInfo?id=" + this.$route.query.id)
        .then(res => {
          if (res.succeed) {
            this.userInfo = res.data;
            this.userInfo.roleText =
              this.userInfo.role == 1
                ? "校友"
                : this.userInfo.role == 2
                ? "企业"
                : this.userInfo.role == 3
                ? "教职工"
                : this.userInfo.role == 4
                ? "管理员"
                : this.userInfo.role == 5
                ? "在校生"
                : "-";
            console.log(this.userInfo.educations);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    async getResumeUser() {
      const params = { userId: this.$route.query.id };
      let res = await ResumeUserApi(params);
      if (res.succeed) {
        this.resumeData = res.data;
      }
    },
    async getUserFileApi() {
      const params = { userId: this.$route.query.id };
      let res = await GetUserFileApi(params);
      if (res.succeed) {
        this.userFile = res.data.filter(item => {
          return item.isShow;
        });
      }
    }
  },
  components: {
    release,
    education,
    Faculty,
    admin,
    enterprise
  }
};
</script>
<style lang="scss" scoped>
.resume {
  font-weight: 400;
  font-size: 14px;
  span {
    color: #5f79f9;
    cursor: pointer;
  }
  img {
    width: 0.15rem;
    height: 0.16rem;
    object-fit: contain;
  }
}
.dialog-body {
  .user-top {
    display: flex;
    justify-content: space-between;
    .user-name {
      display: flex;
      align-items: center;
      .name {
        font-weight: bold;
        font-size: 30px;
        color: #333333;
      }
      .tag {
        margin-left: 0.18rem;
        font-weight: 400;
        font-size: 14px;
        color: #5f79f9;
      }
    }
    .file {
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      color: #5f79f9;
      img {
        width: 0.15rem;
        height: 0.16rem;
        object-fit: contain;
      }
    }
  }
  .user-info {
    margin-top: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: start;
    .title {
      font-weight: 400;
      font-size: 18px;
      color: #333333;
    }
    .edu-list {
      width: 85%;
      display: flex;
      justify-content: space-between;
      margin-top: 0.22rem;
      .edu-item {
        display: flex;
        flex-direction: column;
        align-items: start;
        .name {
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
      }
    }
  }
  .user-tabs {
    margin-top: 0.4rem;
    .tab-main {
      padding: 0.1rem 0.4rem;
      max-height: 4rem;
      overflow-y: auto;

      .through-list {
        display: flex;
        flex-direction: column;
        .through-item {
          display: flex;
          flex-direction: column;
          align-items: start;
          padding-bottom: 0.2rem;
          border-bottom: 1px solid #eee;
          .time-line {
            display: flex;
            .time {
              font-weight: 400;
              font-size: 14px;
              color: #5f79f9;
            }
            .position {
              margin-left: 0.3rem;
              font-weight: 400;
              font-size: 14px;
              color: #5f79f9;
            }
          }
          .company-name {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            margin: 0.15rem 0 0.2rem 0;
          }
          .work-description {
            display: flex;
            flex-direction: column;
            align-items: start;
            .title {
              font-weight: 400;
              font-size: 14px;
              color: #333333;
            }
            .work-inner {
              font-weight: 400;
              font-size: 14px;
              color: #666666;
            }
          }
        }
        .through-item:nth-child(n + 2) {
          margin-top: 0.2rem;
        }
      }
    }
  }
}
.boxInfo {
  padding: 0 0.7rem;
}
.iconImg {
  vertical-align: middle;
  margin-right: 6px;
}
.adminInfo {
  margin-left: 20px;
  padding: 0.5px 12px;
  color: #198cff;
  background: rgba(46, 155, 255, 0.1);
  border: 1px solid #2e9bff;
  border-radius: 4px;
  display: inline-block;
}
.adminInfo:first-child,
.adminInfo:nth-child(4n) {
  margin-left: 0;
}
.adminInfo:nth-child(n + 3) {
  margin-top: 10px;
}
.eduSchool {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #333333;
}
.detail {
  .section_3 {
    padding: 0.1rem 0.1rem;
    flex-shrink: 0;
    background-color: rgb(255, 255, 255);
    border-radius: 0.06rem;
    .group_6 {
      padding: 0 0.43rem;
      .image_5 {
        align-self: center;
        width: 1.4rem;
        height: 1.4rem;
      }
      .group_7 {
        margin-top: 0.17rem;
        .group_8 {
          padding: 0 0.22rem;
          color: rgb(46, 155, 255);
          font-size: 0.2rem;
          font-family: Microsoft YaHei;
          font-weight: 700;
          line-height: 0.17rem;
          justify-content: center;
          .text_11 {
            margin-top: 0.08rem;
          }
          .image_6 {
            margin-left: 0.13rem;
            width: 0.17rem;
            height: 0.24rem;
          }
        }
        .text_12 {
          margin-top: 0.09rem;
          align-self: flex-start;
          color: rgb(102, 102, 102);
          font-size: 0.16rem;
          font-family: Microsoft YaHei;
          line-height: 0.16rem;
          width: 100%;
          text-align: center;
        }
      }
    }
    .group_9 {
      width: 90%;
      display: flex;
      justify-content: space-between;
      margin-top: 0.24rem;
      // padding: 0 0.13rem;
      color: rgb(102, 102, 102);
      font-size: 0.16rem;
      font-family: Microsoft YaHei;
      line-height: 0.16rem;
      .text-wrapper_1 {
        padding: 0.08rem 0.3rem;
        background-color: rgb(233, 248, 255);
      }
      .text_14 {
        align-self: center;
        padding: 0.08rem 0.2rem;
      }
    }
    .text_15 {
      margin-top: 0.25rem;
      margin-left: 0.15rem;
      align-self: flex-start;
      color: rgb(102, 102, 102);
      font-size: 0.16rem;
      font-family: Microsoft YaHei;
      line-height: 0.12rem;
    }
    .group_10 {
      padding: 0 0.14rem;
      .text_16 {
        color: rgb(51, 51, 51);
        font-size: 0.18rem;
        font-family: Microsoft YaHei;
        line-height: 0.17rem;
      }
      .text_18 {
        margin-top: 0.17rem;
        color: rgb(102, 102, 102);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.16rem;
      }
      .text_20 {
        margin-top: 0.17rem;
        color: rgb(102, 102, 102);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.15rem;
      }
      .text_22 {
        margin-top: 0.2rem;
        color: rgb(102, 102, 102);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.15rem;
      }
      .text_24 {
        margin-top: 0.13rem;
        color: rgb(102, 102, 102);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.15rem;
      }
      .text_26 {
        margin-top: 0.16rem;
        color: rgb(102, 102, 102);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.16rem;
      }
    }
    .view {
      margin-top: 0.5rem;
    }
    .divider {
      margin-top: 0.3rem;
      background-color: rgb(221, 221, 221);
      height: 0.01rem;
    }
    .view_1 {
      margin-top: 0.3rem;
    }
  }
}
>>> .carousel_empty .el-empty__image {
  height: 1.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/view/userManagement/userDetail.vue